module.exports = __webpack_public_path__ + "static/dispatch-center-4f3630a631b3c801f5f90c17f1ee0ff4.jpeg";